import useResponsiveWithHydrationFix from "@hooks/useResponsiveWithHydrationFix";
import ALPopup from "@components/al_components/ALPopup";
import "@components/sideCart/giftPackagingPopup/style.scss";

function GiftPackagingWrapper({ children }) {
  const component = useResponsiveWithHydrationFix(
    <div className="fixed inset-0 bg-white z-[11] flex flex-col overflow-y-auto">{children}</div>,
    <ALPopup isOpen customClass="gift-packaging" showCloseIcon={false} noContentPadding>
      {children}
    </ALPopup>
  );
  return component;
}

export default GiftPackagingWrapper;
